import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { setNavigate } from '../helpers/navigationService';

export const NavigationService = ({ isEmbed = false }: { isEmbed: boolean }) => {
  const navigateFn = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setNavigate(navigateFn);
  }, []);

  useEffect(() => {
    if (location.pathname === '/') {
      return
    }
    if (isEmbed) {
      window.parent.postMessage({ type: 'ROUTE_CHANGE', path: location.pathname }, '*');
    } else {
      window.postMessage({ type: 'ROUTE_CHANGE', path: location.pathname }, '*');
    }
  }, [location.pathname]);

  useEffect(() => {
    // When the other app sends a message, navigate here
    const onMessage = (event: MessageEvent) => {
      if (event.data?.type === 'ROUTE_CHANGE' && event.data.path !== location.pathname) {
        if (event.data.path === '/') {
          return;
        }
        navigateFn(event.data.path);
      }
    };
    if (!isEmbed) {
      window.parent.addEventListener('message', onMessage);
    } else {
      window.addEventListener('message', onMessage);
    }
    return () => {
      if (!isEmbed) {
        window.parent.removeEventListener('message', onMessage);
      } else {
        window.removeEventListener('message', onMessage);
      }
    };
  }, [location.pathname]);

  return null;
};

export default NavigationService;
